import React from 'react';
import { createRoot } from 'react-dom/client';
import { Player } from './Player.jsx';
import { PlayerAddButton } from './PlayerAddButton.jsx';

document.addEventListener("DOMContentLoaded", function() {
    const container = document.getElementById('player');
    const root = createRoot(container); // createRoot(container!) if you use TypeScript
    root.render(<Player></Player>);

    const playButtons = document.getElementsByClassName('js-play-release');
    Array.from(playButtons).forEach(
        function(element, index, array){
            let root = createRoot(element);
            root.render(<PlayerAddButton {...element.dataset}></PlayerAddButton>);
        }
    )
});


document.addEventListener("turbo:render", function() {
    const playButtons = document.getElementsByClassName('js-play-release');
    Array.from(playButtons).forEach(
        function(element, index, array){
            let root = createRoot(element);
            root.render(<PlayerAddButton {...element.dataset}></PlayerAddButton>);
        }
    )
});